import { DEFAULT_PROGRESSION as P } from '../../rules/progression/config'
import './prototype.css'

const LOW_MS = 60000

// A sync seat's clock at `now` (warHost.clockLeft, without loading the
// server's rules module into the page). A clock that started a moment ahead
// of this device's own clock hasn't lost any time yet.
export function clockLeftMs(war, seat, now) {
    const c = war?.clock?.[seat]
    if (!c) return null
    return c.runningSince == null ? c.leftMs : c.leftMs - Math.max(0, now - c.runningSince)
}
export const mmss = (ms) => {
    const s = Math.max(0, Math.ceil(ms / 1000))
    return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
}

function Side({ war, seat, now, side, label }) {
    const left = clockLeftMs(war, seat, now)
    const fill = Math.min(1, Math.max(0, left / (P.inputs.syncClockSeconds * 1000)))
    const running = war.clock[seat].runningSince != null
    const cls = ['pt-clock__side', `pt-clock__side--${side}`, running && 'pt-clock__side--running', left < LOW_MS && 'pt-clock__side--low']
    return (
        <div className={cls.filter(Boolean).join(' ')} role="timer" aria-label={`${label} clock ${mmss(left)}${running ? '' : ', paused'}`}>
            <span className="pt-clock__time">{mmss(left)}</span>
            <span className="pt-clock__track"><span className="pt-clock__fill" style={{ transform: `scaleX(${fill})` }} /></span>
        </div>
    )
}

// A sync war's chess clocks along the bottom of the war header, You on the
// left and Opp on the right, each bar draining from its outer edge inward. The
// clock that's ticking is lit, a paused one is dim, and under a minute left
// goes red and pulses.
export default function WarClock({ war, seat, now }) {
    if (!war?.clock) return null
    const other = seat === 'p1' ? 'p2' : 'p1'
    return (
        <div className="pt-clock">
            <Side war={war} seat={seat} now={now} side="you" label="Your" />
            <Side war={war} seat={other} now={now} side="opp" label="Their" />
        </div>
    )
}
